import { put, takeEvery } from 'redux-saga/effects';
import { updateAddonsSuccess, updateAddonsFailure, startFetchAllAddons } from 'redux/addons/actions';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import AddonsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';
const { API_BASE_URL } = urls || {};

export function* updateAddon({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/addons`;

  const response = yield request({
    method: 'put',
    data,
    url,
  });
  if (response.success) {
    Notify(`Addon ${data?.enabled ? 'enabled' : 'disabled'} Successfully`, {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    yield put(updateAddonsSuccess(response.raw));
    yield put(startFetchAllAddons());
    cb();
  } else {
    yield put(updateAddonsFailure(response.message)); 

    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* onUpdateAddon() {
  yield takeEvery(AddonsActionTypes.UPDATE_ADDON, updateAddon);
}
